// extracted by mini-css-extract-plugin
export default {"containerDes":"HomeDescription_containerDes__QNmWX","description":"HomeDescription_description__GyiKY","dkhla":"HomeDescription_dkhla__lV3XA"};